import React, { Component } from 'react'
import TSelect from '../../common/TSelect'
import TButton from '../../common/TButton'
import { connect } from 'react-redux'
import { changeCommentRecognition } from '../../../actions/setting/blog';
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import TInputForm from "../../common/TInputForm";
import autobind from 'autobind-decorator'
import {addPrefix} from "../../../utils/UriUtil";

@connect(null, dispatch => ({
  handleChangeUseCommentRecognition: (useCommentRecognition) => {
    dispatch(changeCommentRecognition(useCommentRecognition))
  },
  dispatch
}))
class CommentSettingForm extends Component {
  constructor(props) {
    super(props);

    const showCommentWriterPermission = (props.data.selected.allowGuestComment == 1);
    this.state = {
      optionList : props.data.optionList,
      initialSelected : props.data.selected,
      selected: props.data.selected,
      changed : {},
      showCommentWriterPermission : showCommentWriterPermission,
    };

  }

  @autobind
  changeSelection(property, value) {

    const { selected, changed }= this.state;
    let diff = {};
    diff[property] = value;

    this.checkLayerToggle(property, value);

    this.setState({
      selected : Object.assign({}, selected, diff),
      changed : Object.assign({}, changed, diff),
    });
  }

  @autobind
  checkLayerToggle(property, value) {

    let layerToggle = {};

    if(property == 'allowGuestComment') {
      if(value == 1)
        layerToggle['showCommentWriterPermission'] = true;
      else
        layerToggle['showCommentWriterPermission'] = false;
    }

    this.setState(layerToggle);
  }

  @autobind
  changeCountValue(propertyName, value) {

    const { selected, changed }= this.state;

    if(value > 30){
      value = 30;
      event.target.value = 30;
    }

    if(value < 0){
      value = 1;
      event.target.value = 1;
    }

    const change = { [propertyName] : value};

    this.setState({
      selected : Object.assign({}, selected, change),
      changed : Object.assign({}, changed, change),
    });
  }

  @autobind
  commentsOnGuestbookChange(value) {this.changeCountValue('commentsOnGuestbook', value);}

  @autobind
  handleSave(callback, failCallback){

    const { selected, changed }= this.state;
    const { handleChangeUseCommentRecognition, dispatch } = this.props;
    fetch(addPrefix("/manage/setting/comments"),
      {
        method: 'put',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(changed)
      })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        callback();
        handleChangeUseCommentRecognition(selected['useCommentRecognition']);
        this.setState({
          initialSelected : this.state.selected
        });
      })
      .catch(e => {
        console.log(e);
        failCallback();
      });
  }

  render() {

    const { optionList, initialSelected, selected, showCommentWriterPermission } = this.state;

    return (
      <form className="wrap_set">
        <fieldset>
          <legend className="screen_out">댓글 표시/작성 권한 설정</legend>
          <div className="item_set">
            댓글 작성은
            <TSelect defaultClassName={'opt_set opt_filter2'} selectItem={this.changeSelection} propertyName={"commentWritePermission"} selected={selected} optionList={optionList} />
            가능합니다.
          </div>
          <div className="item_set">
            댓글은
            <TSelect defaultClassName={'opt_set opt_filter1'} selectItem={this.changeSelection} propertyName={"useCommentRecognition"} selected={selected} optionList={optionList} />
            표시합니다.
          </div>
        </fieldset>

        <fieldset>
          <legend className="screen_out">방명록 표시/작성 권한 설정</legend>
          <div className="item_set">
            방명록 작성을
            <TSelect defaultClassName={'opt_set opt_filter3'} selectItem={this.changeSelection} propertyName={"allowGuestComment"} selected={selected} optionList={optionList} />
            합니다.
          </div>
          <div className="item_set item_sub" style={ { display: (showCommentWriterPermission)? 'block': 'none' } }>
            방명록 작성은
            <TSelect defaultClassName={'opt_set opt_filter2'} selectItem={this.changeSelection} propertyName={"allowWriteDoubleCommentOnGuestbook"} selected={selected} optionList={optionList} />
            가능합니다.
          </div>
          <div className="item_set item_sub" style={ { display: (showCommentWriterPermission)? 'block': 'none' } }>
            방명록은
            <TSelect defaultClassName={'opt_set opt_filter1'} selectItem={this.changeSelection} propertyName={"useGuestbookRecognition"} selected={selected} optionList={optionList} />
            표시합니다.
          </div>
          <div className="item_set">
            방명록은 한 화면에
            <TInputForm type="number" min="1" max="30" className="tf_set tf_reply" value={selected.commentsOnGuestbook} onChange={this.commentsOnGuestbookChange} />
            개 표시합니다.
          </div>
        </fieldset>

        <fieldset>
          <legend className="screen_out">저장 버튼</legend>
          <TButton onClick={this.handleSave} initialValues={initialSelected} currentValues={selected}/>
        </fieldset>
      </form>
    );
  }
}

export default CommentSettingForm
